import type { TextFieldProps } from '@launchpad-ui/components';
import { TextField as LaunchpadTextField } from '@launchpad-ui/components';

import { useFieldContext } from '../../contexts';

export interface FormTextFieldProps extends TextFieldProps {}

export function TextField({ children, ...props }: FormTextFieldProps) {
  const field = useFieldContext<string>();

  return (
    <LaunchpadTextField
      {...props}
      name={field.name}
      value={field.state.value}
      isInvalid={!field.state.meta.isValid}
      onChange={(val: string) => {
        field.handleChange(val);
      }}
      onBlur={() => {
        field.handleBlur();
      }}
    >
      {children}
    </LaunchpadTextField>
  );
}
